const ROLES = {
  admin: 'ROLE_ADMIN',
  superAdmin: 'ROLE_SUPER_ADMIN',
  shopManager: 'ROLE_SHOP_MANAGER',
  calculatorUser: 'ROLE_CALCULATOR_USER',
  subDealer: 'ROLE_SUB_DEALER',
  dealer: 'ROLE_DEALER',
  distributor: 'ROLE_DISTRIBUTOR',
  god: 'ROLE_THE_GOD',
};

const SECTION_ACCESS = {
  tradeOfferManagement: 'SECTION_TRADE_OFFER_MANAGEMENT',
  tradeStoreManagement: 'SECTION_TRADE_STORE_MANAGEMENT',
  seoManagement: 'SECTION_SEO_MANAGEMENT',
};

const ACTION_ACCESS = {
  tradeOfferManagement: 'ACTION_TRADE_OFFER_MANAGEMENT',
  tradeStoreManagement: 'ACTION_TRADE_STORE_MANAGEMENT',
  seoManagement: 'ACTION_SEO_MANAGEMENT',
};

class AccessChecker
{
  constructor() {
    this.possibleRoles = null;
    this.authorized = false;
  }

  init(userData) {
    this.possibleRoles = userData.possibleRoles || [];
    this.authorized = userData.authorized || false;
  }

  hasAccess(role) {
    if (null === this.possibleRoles || false === this.authorized) {
      return false;
    }
    return this.possibleRoles.indexOf(role) !== -1;
  }

  hasAccessOnly(role) {
    if (null === this.possibleRoles || false === this.authorized) {
      return false;
    }
    return this.possibleRoles.length === 2 && this.possibleRoles.indexOf(role) !== -1;
  }

  isAuthorized() {
    return this.authorized;
  }

  getRoles() {
    return this.possibleRoles;
  }
}

const accessChecker = new AccessChecker();

export { accessChecker as AccessChecker };

export const getRoles = () => accessChecker.getRoles();

export const isAuthorized = () => accessChecker.isAuthorized();

export const hasAccess = {
  admin: () => accessChecker.hasAccess(ROLES.admin),
  superAdmin: () => accessChecker.hasAccess(ROLES.superAdmin),
  shopManager: () => accessChecker.hasAccess(ROLES.shopManager),
  calculatorUser: () => accessChecker.hasAccess(ROLES.calculatorUser),
  subDealer: () => accessChecker.hasAccess(ROLES.subDealer),
  dealer: () => accessChecker.hasAccess(ROLES.dealer),
  distributor: () => accessChecker.hasAccess(ROLES.distributor),
  god: () => accessChecker.hasAccess(ROLES.god),
  role: (role) => accessChecker.hasAccess(role),
};

export const hasAccessOnly = {
  admin: () => accessChecker.hasAccessOnly(ROLES.admin),
  superAdmin: () => accessChecker.hasAccessOnly(ROLES.superAdmin),
  shopManager: () => accessChecker.hasAccessOnly(ROLES.shopManager),
  calculatorUser: () => accessChecker.hasAccessOnly(ROLES.calculatorUser),
  subDealer: () => accessChecker.hasAccessOnly(ROLES.subDealer),
  dealer: () => accessChecker.hasAccessOnly(ROLES.dealer),
  distributor: () => accessChecker.hasAccessOnly(ROLES.distributor),
  god: () => accessChecker.hasAccessOnly(ROLES.god),
  role: (role) => accessChecker.hasAccessOnly(role),
};

export const canSee = {
  tradeOfferManagement: () => accessChecker.hasAccess(SECTION_ACCESS.tradeOfferManagement),
  tradeStoreManagement: () => accessChecker.hasAccess(SECTION_ACCESS.tradeStoreManagement),
  seoManagement: () => accessChecker.hasAccess(SECTION_ACCESS.seoManagement),
  section: (section) => accessChecker.hasAccess(section),
};

export const canDo = {
  tradeOfferManagement: () => accessChecker.hasAccess(ACTION_ACCESS.tradeOfferManagement),
  tradeStoreManagement: () => accessChecker.hasAccess(ACTION_ACCESS.tradeStoreManagement),
  seoManagement: () => accessChecker.hasAccess(ACTION_ACCESS.seoManagement),
  action: (action) => accessChecker.hasAccess(action),
};